import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";

import type { BlockInterface } from "@ihr-radioedit/inferno-core";
import type { FeedResultFragment } from "@ihr-radioedit/inferno-webapi";
import { Heading } from "../../../../core/ui";
import { getFeedSubtitle } from "../../lib/coastFeed";
import { CoastFeedNavigation } from "./coast-feed-navigation/CoastFeedNavigation.component";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedGuestItem } from "./CoastFeedGuestItem.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import type { Store } from "../../../../../client/stores";

interface CoastFeedGuestsProps {
    content: FeedResultFragment[] | null;
    block: BlockInterface;
    store?: Store;
    title: string;
}

export const CoastFeedGuests = inject("store")(({ store, content, block, title }: CoastFeedGuestsProps) => {
    if (!store) {
        return null;
    }

    const subtitle = useMemo(() => getFeedSubtitle(store.routeParams), [store.routeParams]);

    return (
        <Fragment>
            <Heading level={2}>{title}</Heading>
            <Heading level={3}>{subtitle}</Heading>

            <CoastFeedNavigation displayHostCategories={false} />

            {content?.length ? (
                <div className="feed-cards">
                    {content.map((item, itemIdx) => (
                        <Fragment key={item.id}>
                            <CoastFeedGuestItem item={item} />
                            <CoastFeedAds
                                blockSize={block.value.size}
                                itemCount={content.length}
                                includeItemAd={false}
                                blockId={block.id}
                                itemIdx={itemIdx}
                            />
                        </Fragment>
                    ))}
                </div>
            ) : (
                <CoastFeedNoResults />
            )}
        </Fragment>
    );
});

export default CoastFeedGuests;
